import { render, staticRenderFns } from "./Decoration.vue?vue&type=template&id=36c31670&scoped=true&"
import script from "./Decoration.vue?vue&type=script&lang=js&"
export * from "./Decoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c31670",
  null
  
)

export default component.exports